import React, { useState } from 'react';
import AdminSidebar from './AdminSidebar';
import AdminTopbar from './AdminTopbar';

const AdminLayout = ({ activeTab, onTabChange, pendingCount, children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50/80">
      <AdminSidebar
        activeTab={activeTab}
        onTabChange={(t) => { onTabChange(t); setMobileOpen(false); }}
        pendingCount={pendingCount}
        collapsed={collapsed}
        onToggle={() => setCollapsed(!collapsed)}
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />
      <div className={'transition-all duration-200 ' + (collapsed ? 'lg:ml-[60px]' : 'lg:ml-[220px]')}>
        <AdminTopbar
          onMenuOpen={() => setMobileOpen(true)}
          activeTab={activeTab}
        />
        <main className="p-4 lg:p-6 max-w-[1400px] mx-auto">
          {children}
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
